import {
  observableValue,
  useEffect,
  useRef,
  useSharedState,
  view,
} from '@esui/core';
import '@material/mwc-formfield';
import '@material/mwc-switch';
import { Switch as MDCSwitch } from '@material/mwc-switch';
import { html } from 'lit';
import { ref } from 'lit/directives/ref.js';

export const [Switch] = view('esui-mwc-switch', {
  Props: class {
    selected = observableValue(false);
    disabled = false;
  },

  mapBuilder:
    SwitchBuilder =>
    (selected = observableValue(false)) =>
      SwitchBuilder().selected(selected),

  template(props) {
    const selected = useSharedState(props.selected);
    const inputRef = useRef<MDCSwitch>();

    useEffect(
      element => {
        element.focus = () => {
          inputRef.value?.focus();
        };
        element.click = () => {
          inputRef.value?.click();
        };
      },
      [inputRef.value]
    );

    function handleClick(e: { target: MDCSwitch }) {
      selected.value = e.target.selected;
    }

    return html`
      <mwc-switch
        ${ref(inputRef)}
        ?selected="${selected.value}"
        ?disabled="${props.disabled}"
        @click="${handleClick}"
      ></mwc-switch>
    `;
  },
});
